<template>
    <div class="app-layers">
        <div v-if="$auth.ready()" class="app-content" :class="{'lang-switch-activated' : $auth.check()&&$auth.user().preferred_lang!== $i18n.locale}">

            <locale-switcher v-if="$auth.check()&&$auth.user().preferred_lang!== $i18n.locale"></locale-switcher>

            <div
                v-if="isImpersonated"
                class="alert alert-warning d-flex justify-content-between align-items-center mb-0 rounded-0"
            >
                <span>
                    Vous êtes connecté en tant que {{ user.firstname }} {{ user.lastname }}
                </span>
                <button class="btn btn-sm btn-outline-dark" @click="stopImpersonation">
                    Quitter
                </button>
            </div>

            <router-view></router-view>

            
        </div>
        <div v-if="!$auth.ready()">
            <span class="loader"></span>
        </div>
        
        <modal-new-feature v-if="$auth.check()&&$auth.user().preferred_lang=='fr'" :modalShow="modalNewFeatureShow" :key="modalKey"/>

    </div>
</template>
<script>
import LocaleSwitcher from "./components/Shared/LocaleSwitcher";

const ModalNewFeature = () => import(/* webpackChunkName: "group-dashboard" */"./components/Shared/ModalNewFeature");

export default {
    name: "App",
    components:{LocaleSwitcher, ModalNewFeature},
    data() {
        return {
            modalNewFeatureShow: false,
            modalKey: 1,
        }
    },
    methods:{
        showModal() {
            this.modalKey = 2
            this.modalNewFeatureShow = true;
        },
        async stopImpersonation() {
            try {
                await axios.post('/impersonate/leave');
                await this.$auth.fetch();
                this.$router.push({name: 'AdminUsersList'});
            } catch (error) {
                console.error('Impossible d’arrêter l’impersonation:', error);
            }
        },
    },
    computed: {
        user() {
            if (this.$auth.check()) return this.$auth.user()
        },
        isImpersonated() {
            return this.$auth.check()
                && this.$auth.user()
                && this.$auth.user().is_impersonated;
        }
    },
    updated(){
        // if ((this.$auth.check() && this.$auth.ready() && !this.user.view_modal_feature) && (!this.$route.query.pid_origin && !this.user.pid_origin)) {
        //     this.showModal()
        // }   
    }
}
</script>
